<template>
  <v-breadcrumbs :items="breadcrumpItems">
    <template v-slot:divider>
        <v-icon>mdi-forward</v-icon>
    </template>
    <template v-slot:item="{ item }">
        <v-breadcrumbs-item
          :href="item.href"
          :disabled="item.disabled"
        >
         <b> {{ item.text.toUpperCase() }} </b>
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
</template>
<script>
import breadcrumbs from '../store/breadcrumbs.js'

export default {
  name: 'BreadCrumb',
  components:{
  },
  data: () => ({
  }),
  computed: {
    breadcrumpItems () {
      return breadcrumbs.getters.getBreadCrumps;
    }
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>
</style>
